import toast from "react-hot-toast";
import Logo from "./../Images/logo.png";
export const BasicInfo = {
  logo: Logo,
  // logoIcon: LogoIcon,
  projectName: "Aethrx",
  isDebug: true,
  ChainId: 97,
  Currency_sign: "$",
  basepath: 'https://apis.mtxzone.online',
  testnetLink: "https://bscscan.com/address/",
  // Telegram Bot Configuration
  telegramBot: {
    username: "mtxturbobot", // Replace with your actual bot username
    botToken: "8489030105:AAEQ7DTUaidbq2US0ScbexDBvyiMvgcAeuA", // Replace with your actual bot token
    webAppUrl: "https://mtxzone.online", // Your web app URL
    startCommand: "/launch"
  }
};
export const toastSuccess = (msg) => toast.success(msg);
export const toastFailed = (msg) => toast.error(msg);
